import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { editEventTemplate } from '@pingum/app-state-management/eventTemplate/actions';

export class RestoreTaskModalComponent extends React.Component {
  handleRestoreConfirm = () => {
    this.props.eventTemplateIds.forEach((eventTemplateId) => this.props.editEventTemplate(eventTemplateId, { archived: false }));
    this.props.handleCloseModal();
  }

  render() {
    const { eventTemplateIds } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          onClose={this.props.handleCloseModal}
          aria-labelledby="edit-user-title"
          aria-describedby="edit-user-description"
          id="edit-user-dialog"
        >
          <DialogTitle id="edit-user-title">
            {
              eventTemplateIds.length > 1
                ? 'Restore Tasks'
                : 'Restore Task'
            }
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="restore-event-template-description">
              <strong>Are you sure you want to perform this action?</strong>
            </DialogContentText>
          </DialogContent>
          <DialogContentText>
            You will perform this action on {eventTemplateIds.length}
            {
              eventTemplateIds.length > 1
                ? ' tasks'
                : ' task'
            }
          </DialogContentText>
          <DialogActions>
            <Button
              onClick={this.props.handleCloseModal}
              id="cancel-restore-button"
            >
              Cancel
            </Button>
            <Button
              onClick={() => { this.handleRestoreConfirm(); }}
              color="primary"
              autoFocus
              id="confirm-restore-button"
            >
              Restore
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

RestoreTaskModalComponent.propTypes = {
  eventTemplateIds: PropTypes.arrayOf(PropTypes.number),
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  editEventTemplate: PropTypes.func,
};

RestoreTaskModalComponent.defaultProps = {
  eventTemplateIds: [null],
  isOpen: false,
  handleCloseModal: () => { },
  editEventTemplate: () => {},
};

export const mapDispatchToProps
  = (dispatch) => ({
    editEventTemplate: (eventTemplateId, request) => dispatch(
      editEventTemplate(eventTemplateId, request),
    ),
  });

export default connect(
  null,
  mapDispatchToProps,
)(RestoreTaskModalComponent);
